import React from "react";
import PropTypes from "prop-types";
import NumericInput from "./numeric-input";

const Range = ({
  className,
  value = {},
  maskType,
  integerLimit,
  minPlaceholder = "",
  maxPlaceholder = "",
  disabled,
  onChange = () => {},
  onKeyPress,
}) => {
  const parseValidInt = (val) => (!Number.isNaN(parseInt(val, 10)) ? parseInt(val, 10) : "");

  const handleChange = (key, changeValue) => {
    if (changeValue === null || changeValue === "") {
      let valueObject = { ...value };
      delete valueObject[key];
      onChange(valueObject);
    } else {
      onChange({ ...value, [key]: changeValue });
    }
  };

  return (
    <div className={`et--number-range ${className ? className : ""}`}>
      <NumericInput
        value={parseValidInt(value.gte)}
        maskType={maskType}
        integerLimit={integerLimit}
        placeholder={minPlaceholder}
        disabled={disabled}
        className="et--number-range--input"
        onChange={(value) => handleChange("gte", value)}
        onKeyPress={onKeyPress}
        aria-label="Greater than or equal to"
      />
      <span className="et--number-range---separator" />
      <NumericInput
        value={parseValidInt(value.lte)}
        maskType={maskType}
        integerLimit={integerLimit}
        placeholder={maxPlaceholder}
        disabled={disabled}
        className="et--number-range--input"
        onChange={(value) => handleChange("lte", value)}
        onKeyPress={onKeyPress}
        aria-label="Less than or equal to"
      />
    </div>
  );
};

Range.propTypes = {
  className: PropTypes.string,
  value: PropTypes.object,
  maskType: PropTypes.string,
  integerLimit: PropTypes.number,
  minPlaceholder: PropTypes.string,
  maxPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
};

export default Range;
